import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ApiService from "@/common/API.service";

// css
import "sweetalert2/dist/sweetalert2.min.css";
import "@/assets/css/tailwind.scss";

// 3td party
import VueSweetalert2 from "vue-sweetalert2";
import VueCrontab from "vue-crontab";
import ShortKey from "vue-shortkey";

Vue.use(VueCrontab);
Vue.use(VueSweetalert2);
Vue.use(ShortKey);

Vue.config.productionTip = false;

ApiService.init();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
